<template>
  <q-card flat>
    <q-card-section class="no-padding" v-if="!readOnly">
      <q-banner class="bg-primary text-white">
        <span v-if="!isArchived">هدف گذاری فروش</span>
        <span v-if="isArchived">آرشیو هدف گذاری فروش</span>
      </q-banner>
    </q-card-section>
    <q-card-section class="q-pa-xs">
      <q-btn label="کپی از اهداف ماه گذشته"
             @click="copyData"
             color="indigo" icon="content_copy"
             v-if="allTargets && allTargets.length>0 && userId===undefined && !isArchived" />
    </q-card-section>
    <q-card-section class="q-pa-xs">
      <div class="row q-gutter-xs">
        <div class="col-xs-12 col-md-5">
          <q-expansion-item
              class="shadow-1 overflow-hidden q-mt-xs"
              icon="track_changes"
              :label="userId===undefined?(isArchived?'آرشیو اهداف تعیین شده':'لیست اهداف تعیین شده'):'اهداف ماه جاری من'"
              header-class="bg-indigo text-white"
              expand-icon-class="text-white"
              style="border-radius: 10px"
              v-if="$store.state.roles.some(v=>['admin','salemanager','user_sell'].includes(v))"
              v-model="targetListPanelVisibility">
            <AuditTargetList :view-only="readOnly" :all-targets="allTargets"
                             :dashboard-view="readOnly"
                             :is-archived ="isArchived"
                             @edit-target="editTarget" @remove-target="removeTarget"/>
          </q-expansion-item>
        </div>
        <div class="col-xs-12 col-md-6" v-if="$route.params.type === 'last' || (reportType!==undefined && reportType==='last') || isArchived">
          <q-expansion-item
              ref="newTarget"
              class="shadow-1 overflow-hidden q-mt-xs"
              icon="track_changes"
              :label="userId===undefined?'تعیین هدف جدید':'جزییات هدف'"
              header-class="bg-indigo text-white"
              expand-icon-class="text-white"
              style="border-radius: 10px"
              v-if="$store.state.roles.some(v=>['admin','salemanager', 'user_sell'].includes(v))"
              v-model="newTargetPanelVisibility"
          >
            <q-stepper
                v-model="step"
                vertical
                animated
                active-color="indigo"
                done-color="green"
                inactive-color="blue"
                flat
                class="no-padding"
            >
              <q-step
                  :name="1"
                  title="بازه زمانی و شرح هدف"
                  icon="calendar_today"
                  :done="step > 1"
              >
                <q-card flat class="q-mt-xs">
                  <q-card-section class="no-padding q-gutter-xs" :horizontal="!$q.screen.lt.md">
                    <q-input :readonly="readOnly || isArchived" :dense="$q.screen.lt.md" dir="ltr" filled v-model="newTarget.startDate" mask="date"
                             label="تاریخ شروع پایش هدف" clearable>
                      <template v-slot:append>
                        <q-icon v-if="!readOnly" name="event" class="cursor-pointer">
                          <q-popup-proxy ref="qStartDateProxy" transition-show="scale" transition-hide="scale">
                            <q-date v-model="newTarget.startDate" calendar="persian">
                              <div class="row items-center justify-center">
                                <q-btn v-close-popup label="تایید" color="primary" flat/>
                                <q-btn v-close-popup @click="newTarget.startDat = ToJalaliDate(new Date())"
                                       label="امروز" color="primary"
                                       flat/>
                              </div>
                            </q-date>
                          </q-popup-proxy>
                        </q-icon>
                      </template>
                    </q-input>
                    <q-input :readonly="readOnly || isArchived" :dense="$q.screen.lt.md" dir="ltr" filled v-model="newTarget.endDate" mask="date"
                             label="تاریخ پایان پایش هدف" clearable>
                      <template v-slot:append>
                        <q-icon v-if="!readOnly" name="event" class="cursor-pointer">
                          <q-popup-proxy ref="qStartDateProxy" transition-show="scale" transition-hide="scale">
                            <q-date v-model="newTarget.endDate" calendar="persian">
                              <div class="row items-center justify-center">
                                <q-btn v-close-popup label="تایید" color="primary" flat/>
                                <q-btn v-close-popup @click="newTarget.endDate = ToJalaliDate(new Date())"
                                       label="امروز" color="primary"
                                       flat/>
                              </div>
                            </q-date>
                          </q-popup-proxy>
                        </q-icon>
                      </template>
                    </q-input>
                  </q-card-section>
                  <q-card-section class="no-padding q-mt-xs">
                    <q-input
                        :readonly="readOnly || isArchived"
                        :dense="$q.screen.lt.md"
                        filled
                        v-model="newTarget.description"
                        type="textarea"
                        counter
                        hint="حداقل عبارت با 15 کارامتر بایستی وارد نمایید"
                        label="شرح مختصر هدف">
                    </q-input>
                  </q-card-section>
                </q-card>
                <q-stepper-navigation class="q-gutter-xs">
                  <q-btn
                      :disable="newTarget.startDate==='' || newTarget.endDate==='' || (newTarget.description==='' || newTarget.description.length<15)"
                      @click="step +=1" color="indigo"
                      icon-right="navigate_before" label="ادامه"/>
                  <q-btn
                      @click="generateNewTraget" color="red" flat
                      icon-right="cancel" label="انصراف"/>
                </q-stepper-navigation>
              </q-step>

              <q-step
                  :name="2"
                  title="حوزه فعالیت"
                  icon="location_on"
                  :done="step > 2"
              >
                <div class="row">
                  <div class="col-xs-12">
                    <q-select
                        :readonly="readOnly || isArchived"
                        :dense="$q.screen.lt.md"
                        filled
                        label="استان های هدف را انتخاب نمایید"
                        v-model="newTarget.states"
                        use-input
                        use-chips
                        multiple
                        input-debounce="0"
                        :options="stateOptions"
                        option-label="State_Name"
                        option-value="State_ID"
                        @filter="stateFilterFn"
                    />
                  </div>
                </div>
                <div class="row">
                  <div class="col-xs-12">
                    <q-select
                        :readonly="readOnly || isArchived"
                        class="q-mt-xs"
                        :dense="$q.screen.lt.md"
                        filled
                        label=" شهرهای هدف را در صورت لزوم انتخاب نمایید"
                        v-model="newTarget.cities"
                        use-input
                        use-chips
                        multiple
                        input-debounce="0"
                        :options="cityOptions"
                        option-label="City_Name"
                        option-value="City_ID"
                        @filter="cityFilterFn"
                    />
                  </div>
                </div>
                <div class="row">
                  <div class="col-xs-12">
                    <q-select
                        :readonly="readOnly || isArchived"
                        class="q-mt-xs"
                        :dense="$q.screen.lt.md"
                        filled
                        label="اصناف"
                        v-model="newTarget.guild"
                        use-input
                        use-chips
                        multiple
                        input-debounce="0"
                        :options="guildOptions"
                        option-label="CSKind_Name"
                        option-value="CSKind_ID"
                        @filter="guildFilterFn"
                    />
                  </div>
                </div>
                <q-stepper-navigation>
                  <q-btn @click="step +=1" color="indigo" icon-right="navigate_before" label="ادامه"/>
                  <q-btn flat @click="step -= 1" color="red" label="برگشت" class="q-ml-sm"/>
                </q-stepper-navigation>
              </q-step>

              <q-step
                  :name="3"
                  title="گروه کالا و یا کالاها"
                  icon="inventory_2"
                  :done="step > 3"
              >
                <div class="row">
                  <div class="col-xs-12">
                    <q-select
                        :readonly="readOnly || isArchived"
                        :dense="$q.screen.lt.md"
                        filled
                        label="گروه کالاهای خود را انتخاب نمایید"
                        v-model="newTarget.goodsGroup"
                        use-input
                        use-chips
                        multiple
                        input-debounce="0"
                        :options="goodsGroupOptions"
                        option-label="Group_Name"
                        option-value="GroupI_D"
                        @filter="goodsGroupFilterFn"
                    />
                  </div>
                </div>
                <div class="row">
                  <div class="col-xs-12">
                    <div class="row">
                      <div class="col-xs-12">
                        <q-select
                            :readonly="readOnly || isArchived"
                            :dense="$q.screen.lt.md"
                            filled
                            label="کالاهای خود را انتخاب نمایید"
                            v-model="newTarget.goods"
                            use-input
                            use-chips
                            multiple
                            input-debounce="0"
                            :options="goodsOptions"
                            option-label="Goods_Name"
                            option-value="Goods_ID"
                            class="q-mt-xs"
                            @filter="goodsFilterFn"
                        />
                      </div>
                    </div>
                    <div class="row" v-if="newTarget.goods.length>0">
                      <div class="col-xs-12">
                        <q-card class="shadow-5">
                          <q-list separator>
                            <q-item v-for="(goodsItem, index) in goodsListTarget"
                                    :key="`${goodsItem.Goods_ID}_${index}`">
                              <q-item-section>
                                <q-card flat>
                                  <q-card-section class="no-padding text-left">
                                    <q-btn padding="none" round flat color="indigo" icon="info"
                                           @click="showProductDetailDialog(goodsItem)"/>
                                    {{ goodsItem.Goods_Name }}
                                  </q-card-section>
                                  <q-card-section class="no-padding q-gutter-sm" horizontal>
                                    <q-input label="تعداد" dense filled type="number"
                                             dir="ltr"
                                             :readonly="readOnly || isArchived"
                                             v-model="goodsItem.targetCount"
                                    />
                                    <q-input label="درصد پورسانت" dense filled type="number"
                                             dir="ltr"
                                             step="0.1"
                                             :readonly="readOnly || isArchived"
                                             v-if="!readOnly"
                                             v-model="goodsItem.targetCountPorsant"
                                    />
                                  </q-card-section>
                                </q-card>
                              </q-item-section>
                            </q-item>
                          </q-list>
                        </q-card>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row q-gutter-xs">
                  <div class="col-xs-12 col-md-5">
                    <q-input
                        :readonly="readOnly || isArchived"
                        :dense="$q.screen.lt.md"
                        filled
                        label="تعداد پیش بینی فروش کالا و یا گروه کالا را مشخص کنید"
                        v-model="newTarget.saleCount"
                        dir="ltr"
                        class="q-mt-xs"
                    />
                  </div>
                  <div class=" col-xs-12 col-md-2">
                    <q-field
                        :readonly="readOnly || isArchived"
                        class="q-mt-xs"
                        filled
                        :dense="$q.screen.lt.md"
                        v-model="newTarget.salePrice"
                        type="number"
                        mask="currency"
                        label="پیش بینی درآمد"
                        label-color="indigo"
                        autofocus
                        dir="ltr"
                        lazy-rules
                        :rules="[val => val.toString().replaceAll(',','') !== null && val.toString().replaceAll(',','') !== '' || 'مبلغ پیش بینی درآمد را وارد نمایید',
                                 val => parseInt(val.toString().replaceAll(',','')) >= 0   || 'مبلغ پیش بینی درآمد عددی بزرگتر صفر می باشد، لطفا اصلاح نمایید'
                                ]">
                      <template v-slot:control="{ id, floatingLabel, value, emitValue }">
                        <input :id="id" class="q-field__native text-right" :value="value"
                               @change="e => emitValue(e.target.value.replaceAll(',',''))"
                               v-money="moneyFormatForDirective"
                               v-show="floatingLabel">
                      </template>
                    </q-field>
                  </div>
                </div>
                <q-stepper-navigation>
                  <q-btn @click="step += 1" color="indigo" icon-right="navigate_before" label="ادامه"/>
                  <q-btn flat @click="step -= 1" color="red" label="برگشت" class="q-ml-sm"/>
                </q-stepper-navigation>
              </q-step>

              <q-step
                  :name="4"
                  title="مشتری"
                  icon="person"
                  :done="step > 4"
              >
                <div class="row q-mt-xs q-gutter-xs">
                  <div class=" col-xs-12 col-md-3 q-gutter-xs">
                    <q-input
                        hide-bottom-space
                        :readonly="readOnly || isArchived"
                        :dense="$q.screen.lt.md"
                        filled
                        dir="ltr"
                        v-model="newTarget.visitCustomer"
                        type="number"
                        label="بازدید در محل مشتری">
                    </q-input>
                    <q-field
                        hide-bottom-space
                        :readonly="readOnly || isArchived"
                        class="q-mt-xs"
                        filled
                        :dense="$q.screen.lt.md"
                        v-model="newTarget.LowBoundSalePerFactor"
                        type="number"
                        mask="currency"
                        label="حداقل فروش به ازای هر فاکتور"
                        label-color="indigo"
                        autofocus
                        dir="ltr"
                        lazy-rules
                        :rules="[val => val.toString().replaceAll(',','') !== null && val.toString().replaceAll(',','') !== '' || 'حداقل فروش به ازای هر فاکتور را وارد نمایید',
                                 val => parseInt(val.toString().replaceAll(',','')) >= 0   || 'حداقل فروش به ازای هر فاکتور عددی بزرگتر صفر می باشد، لطفا اصلاح نمایید'
                                ]">
                      <template v-slot:control="{ id, floatingLabel, value, emitValue }">
                        <input :id="id" class="q-field__native text-right" :value="value"
                               @change="e => emitValue(e.target.value.replaceAll(',',''))"
                               v-money="moneyFormatForDirective"
                               v-show="floatingLabel">
                      </template>
                    </q-field>
                    <q-field
                        hide-bottom-space
                        :readonly="readOnly || isArchived"
                        class="q-mt-xs"
                        filled
                        :dense="$q.screen.lt.md"
                        v-model="newTarget.IndoorTravel"
                        type="number"
                        mask="currency"
                        label="کرایه درون شهری"
                        label-color="indigo"
                        autofocus
                        dir="ltr"
                        lazy-rules
                        :rules="[val => val.toString().replaceAll(',','') !== null && val.toString().replaceAll(',','') !== '' || 'کرایه درون شهری را وارد نمایید',
                                 val => parseInt(val.toString().replaceAll(',','')) >= 0   || 'کرایه درون شهری عددی بزرگتر صفر می باشد، لطفا اصلاح نمایید'
                                ]">
                      <template v-slot:control="{ id, floatingLabel, value, emitValue }">
                        <input :id="id" class="q-field__native text-right" :value="value"
                               @change="e => emitValue(e.target.value.replaceAll(',',''))"
                               v-money="moneyFormatForDirective"
                               v-show="floatingLabel">
                      </template>
                    </q-field>
                    <q-field
                        hide-bottom-space
                        :readonly="readOnly || isArchived"
                        class="q-mt-xs"
                        filled
                        :dense="$q.screen.lt.md"
                        v-model="newTarget.OutdoorTravel"
                        type="number"
                        mask="currency"
                        label="کرایه برون شهری"
                        label-color="indigo"
                        autofocus
                        dir="ltr"
                        lazy-rules
                        :rules="[val => val.toString().replaceAll(',','') !== null && val.toString().replaceAll(',','') !== '' || 'کرایه برون شهری هر فاکتور را وارد نمایید',
                                 val => parseInt(val.toString().replaceAll(',','')) >= 0   || 'کرایه برون شهری عددی بزرگتر صفر می باشد، لطفا اصلاح نمایید'
                                ]">
                      <template v-slot:control="{ id, floatingLabel, value, emitValue }">
                        <input :id="id" class="q-field__native text-right" :value="value"
                               @change="e => emitValue(e.target.value.replaceAll(',',''))"
                               v-money="moneyFormatForDirective"
                               v-show="floatingLabel">
                      </template>
                    </q-field>
                    <q-field
                        hide-bottom-space
                        :readonly="readOnly || isArchived"
                        class="q-mt-xs"
                        filled
                        :dense="$q.screen.lt.md"
                        v-model="newTarget.Reward"
                        type="number"
                        mask="currency"
                        label="پاداش فروش هر مشتری جدید"
                        label-color="indigo"
                        autofocus
                        dir="ltr"
                        lazy-rules
                        :rules="[val => val.toString().replaceAll(',','') !== null && val.toString().replaceAll(',','') !== '' || 'پاداش فروش هر مشتری جدید را وارد نمایید',
                                 val => parseInt(val.toString().replaceAll(',','')) >= 0   || ' پاداش فروش هر مشتری جدید عددی بزرگتر صفر می باشد، لطفا اصلاح نمایید'
                                ]">
                      <template v-slot:control="{ id, floatingLabel, value, emitValue }">
                        <input :id="id" class="q-field__native text-right" :value="value"
                               @change="e => emitValue(e.target.value.replaceAll(',',''))"
                               v-money="moneyFormatForDirective"
                               v-show="floatingLabel">
                      </template>
                    </q-field>
                  </div>

                  <div class="col-xs-12 col-md-3 q-gutter-xs">
                    <q-input
                        :readonly="readOnly || isArchived"
                        :dense="$q.screen.lt.md"
                        filled
                        dir="ltr"
                        v-model="newTarget.newCustomer"
                        type="number"
                        label="مشتری جدید">
                    </q-input>
                    <q-input
                        :readonly="readOnly || isArchived"
                        :dense="$q.screen.lt.md"
                        filled
                        dir="ltr"
                        v-model="newTarget.callCustomer"
                        type="number"
                        label="تماس با مشتری ">
                    </q-input>

                  </div>
                </div>
                <div class="row q-mt-xs q-gutter-xs">
                  <div class="col-xs-12 col-md-4">
                    <q-input
                        :readonly="readOnly || isArchived"
                        :dense="$q.screen.lt.md"
                        filled
                        dir="ltr"
                        v-model="newTarget.PresenterCount"
                        type="number"
                        label="تعداد پیش بینی شده برای معرفی مشتری">
                    </q-input>
                  </div>
                  <div class=" col-xs-12 col-md-3">
                    <q-input
                        :readonly="readOnly || isArchived"
                        :dense="$q.screen.lt.md"
                        filled
                        step="0.1"
                        dir="ltr"
                        v-model="newTarget.PresenterCommision"
                        type="number"
                        label="درصد پورسانت معرفی مشتری">
                    </q-input>
                  </div>
                </div>
                <q-stepper-navigation>
                  <q-btn @click="step += 1" color="indigo" icon-right="navigate_before" label="ادامه"/>
                  <q-btn flat @click="step -= 1" color="red" label="برگشت" class="q-ml-sm"/>
                </q-stepper-navigation>
              </q-step>

              <q-step
                  :name="5"
                  title="کارشناس/کارشناسان"
                  icon="person"
                  :done="step > 5"
              >
                <div class="row">
                  <div class="col-xs-12">
                    <q-select
                        :readonly="readOnly || isArchived"
                        :dense="$q.screen.lt.md"
                        filled
                        label="کارشناسان و بازاریاب ها"
                        v-model="newTarget.employees"
                        use-input
                        use-chips
                        multiple
                        input-debounce="0"
                        :options="employees"
                        option-label="UserName"
                        option-value="Users_ID"
                        class="q-mt-xs"
                    />
                  </div>
                </div>

                <q-stepper-navigation>
                  <q-btn @click="step += 1" v-if="!readOnly" color="indigo" icon-right="navigate_before" label="ادامه"/>
                  <q-btn flat @click="step -= 1" color="red" label="برگشت" class="q-ml-sm"/>
                </q-stepper-navigation>
              </q-step>

              <q-step
                  v-if="!readOnly || isArchived"
                  :name="6"
                  title="بررسی هدف"
                  icon="preview"
              >
                <div class="row">
                  <div class="col-xs-12">
                    شما هدفی در باز زمانی
                    <q-chip outline color="deep-orange" icon-right="calendar_today" :label="newTarget.startDate"/>
                    تا
                    <q-chip outline color="deep-orange" icon-right="calendar_today" :label="newTarget.endDate"/>
                    به شرح <b> {{ newTarget.description }} </b> و بر اساس شرایط زیر تعریف کرده
                    اید:
                  </div>
                </div>
                <div class="row">
                  <div class="col-xs-12">
                    <div class="text-subtitle2 text-bold">
                      محدوده جغرافیایی:
                    </div>
                    <div>
                      <q-chip v-for="item in newTarget.states.map(item => item.State_Name)" :key="item.State_ID"
                              square
                              icon="business"
                              :label="item"/>
                    </div>
                    <div>
                      <q-chip v-for="item in newTarget.cities.map(item => item.City_Name) " :key="item.City_ID" square
                              icon="location_city"
                              :label="item"/>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xs-12">
                    <div class="text-subtitle2 text-bold">
                      با گروه کالا/کالاهای:
                    </div>
                    <div>
                      <q-chip v-for="item in newTarget.goodsGroup.map(item => item.Group_Name)" :key="item.Group_ID"
                              square
                              icon="group_work"
                              :label="item"/>
                    </div>
                    <div>
                      <q-chip v-for="item in newTarget.goods.map(item => item.Goods_Name)"
                              :key="item.Group_ID" square
                              icon="inventory_2"
                              :label="item"/>
                    </div>
                    <div v-if="newTarget.saleCount">
                      <q-chip text-color="white" square color="deep-orange">
                        به تعداد
                        <q-badge align="top" :label="newTarget.saleCount"/>
                        عدد
                      </q-chip>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xs-12">
                    <div class="text-subtitle2 text-bold">
                      کارشناسان / بازاریاب ها:
                    </div>
                    <div v-if="newTarget.employees && newTarget.employees!==[]">
                      <q-chip
                          v-for="item in newTarget.employees" :key="item.Users_ID"
                          square
                          icon="person"
                          :label="item.UserName"/>
                    </div>
                  </div>
                </div>
                <q-stepper-navigation>
                  <q-btn v-if="!readOnly || !isArchived" color="indigo" @click="defineTarget" icon="done" label="تایید"/>
                  <q-btn flat @click="step -= 1" color="red" label="برگشت" class="q-ml-sm"/>
                </q-stepper-navigation>
              </q-step>

            </q-stepper>
          </q-expansion-item>
        </div>
      </div>
    </q-card-section>
    <q-dialog
        :full-width="$q.screen.lt.md"
        v-model="showProductDetails">
      <ProductDetail :product="selectedProductDetails"/>
    </q-dialog>
  </q-card>
</template>

<script>
import {mapActions} from "vuex";
import AuditTargetList from "@/components/SaleTargets/AuditTargetList";
import ProductDetail from "@/components/productInfo/ProductDetail.vue";

export default {
  name: "SaleTargetList",
  components: {ProductDetail, AuditTargetList},
  props: {
    reportType: {
      type: String,
      required: false,
      default: undefined
    },
    userId: {
      type: Number,
      required: false,
      default: undefined
    },
    readOnly:{
      type:Boolean,
      required: false,
      default: false
    },
  },
  data() {
    return {
      moneyFormatForDirective: {
        decimal: '.',
        thousands: ',',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: false
      },
      goodsListTarget: [],
      currentTargetCount: 0,
      step: 1,
      showProductDetails: false,
      targetListPanelVisibility: true,
      newTargetPanelVisibility: true,
      selectedProductDetails: '',
      newTarget: {
        id: '',
        startDate: '',
        endDate: '',
        description: '',
        newCustomer: 0,
        visitCustomer: 0,
        callCustomer: 0,
        states: [],
        cities: [],
        zones: [],
        goodsGroup: [],
        goods: [],
        saleCount: 0,
        employees: [],
        salePrice: 0,
        PresenterCount: 0,
        PresenterCommision: 0,
        LowBoundSalePerFactor:0,
        IndoorTravel:0,
        OutdoorTravel:0,
        Reward:0
      },
      targetResultDialog: false,
      allTargets: [],
      stateList: [],
      cityList: [],
      zoneList: [],
      goodsGroupList: [],
      goodsList: [],
      stateOptions: [],
      cityOptions: [],
      zoneOptions: [],
      goodsGroupOptions: [],
      goodsOptions: [],
      employees: [],
      auditInfo: '',
      guild: [],
      guildOptions: [],
      isArchived:false,
    }
  },
  methods: {
    ...mapActions({
      targetDefinitionData: 'Dashboard/getTargetDefinitionData',
      getArchiveSaleTaret: 'Dashboard/getArchiveTargetsList',
      addTarget: 'Orders/add_sale_target',
      updateTarget: 'Orders/update_sale_target',
      deleteTarget: 'Orders/delete_sale_target',
      getGoodsList: 'Products/getGoodsList',
      copyFromLastMonth:'Targets/copyFromLastTarget'
    }),
    showProductDetailDialog(row) {
      this.selectedProductDetails = row
      this.showProductDetails = true
    },
    stateFilterFn(val, update) {
      update(() => {
        if (val === '') {
          this.stateOptions = this.stateList
        } else {
          this.stateOptions = this.stateList.filter(
              v => v.State_Name.indexOf(val) > -1
          )
        }
      })
    },
    guildFilterFn(val, update) {
      update(() => {
        if (val === '') {
          this.guildOptions = this.guild
        } else {
          this.guildOptions = this.guild.filter(
              v => v.CSKind_Name.indexOf(val) > -1
          )
        }
      })
    },

    cityFilterFn(val, update) {
      update(() => {
        const selectedStates = this.newTarget.states.map(item => item.State_ID)
        if (val === '' && selectedStates.length === 0) {
          this.cityOptions = []
        } else {
          this.cityOptions = this.cityList.filter(
              v => selectedStates.includes(v.State_ID) && v.City_Name.indexOf(val) > -1
          )
        }
      })
    },
    goodsGroupFilterFn(val, update) {
      update(() => {
        if (val === '') {
          this.goodsGroupOptions = this.goodsGroupList
        } else {
          this.goodsGroupOptions = this.goodsGroupList.filter(
              v => v.Group_Name.indexOf(val) > -1
          )
        }
      })
    },
    goodsFilterFn(val, update) {
      update(() => {
        const selectedGoodsGroup = this.newTarget.goodsGroup.map(item => item.Group_ID)
        if (val === '' && selectedGoodsGroup.length === 0) {
          this.goodsOptions = []
        } else {
          this.goodsOptions = this.goodsList.filter(
              v => selectedGoodsGroup.includes(v.Goods_Group) && v.Goods_Name.indexOf(val) > -1
          )
        }
      })
    },
    defineTarget() {
      this.goodsListTarget.forEach(item => {
        item.targetCount = parseInt(item.targetCount.toString());
        item.targetCountPorsant = parseFloat(item.targetCountPorsant.toString())
      })
      this.newTarget.goods = Object.assign([], this.goodsListTarget)
      if (!('guild' in this.newTarget)) {
        this.newTarget.guild = []
      }
      this.addTarget(this.newTarget).then((res) => {
        if (this.newTarget.id === '') {
          this.allTargets.push(res.data)
        }
        this.generateNewTraget()
        this.step = 1
        this.$q.notify({
          type: 'positive',
          color: 'positive',
          message: 'هدف شما به لیست اهداف اضافه گردید',
          position: 'top'
        })
      })
    },
    generateNewTraget() {
      this.newTarget = {
        id: '',
        startDate: '',
        endDate: '',
        description: '',
        newCustomer: 0,
        visitCustomer: 0,
        callCustomer: 0,
        states: [],
        cities: [],
        zones: [],
        goodsGroup: [],
        goods: [],
        saleCount: 0,
        employees: [],
        salePrice: 0,
        guild: [],
        PresenterCount: 0,
        PresenterCommision :0
      }
    },
    removeTarget(rowInfo) {
      this.deleteTarget(rowInfo.row.id).then(() => {
        this.allTargets.splice(rowInfo.rowIndex, 1)
      })
    },
    editTarget(rowInfo) {
      this.newTarget = rowInfo
      if (rowInfo.employees === null) {
        this.newTarget.employees = null
      } else {
        this.newTarget.employees = eval(rowInfo.employees)
      }
      if (this.$q.screen.lt.md) {
        this.targetListPanelVisibility = false
        this.newTargetPanelVisibility = true
      }
      this.goodsListTarget = Object.assign([], this.newTarget.goods)
      if (rowInfo.guild === undefined) {
        rowInfo.guild = []
      }
    },
    copyData(){
      this.copyFromLastMonth((res)=>{
        if (res.result === 1){
          this.loadData()
        }
      })
    },
    loadData(){
      if (this.$route.params.type === 'last' || (this.reportType!==undefined && this.reportType==="last")) {
        this.targetDefinitionData().then((res) => {
          this.stateList = JSON.parse(res.state)
          this.stateOptions = this.stateList
          this.cityList = JSON.parse(res.city)
          this.zoneList = JSON.parse(res.zone)
          this.goodsGroupList = JSON.parse(res.goods_group)
          this.goodsList = JSON.parse(res.goods)
          this.guild = JSON.parse(res.guild)
          this.guildOptions = this.guild
          this.goodsList.forEach((record) => {
            record.targetCount = 0
            record.targetCountPorsant = 0.0
          })
          this.employees = eval(res.employees)
          this.allTargets = JSON.parse(res.all_targets)
          if (this.userId!==undefined){
            this.allTargets = this.allTargets.filter(item=> item.employees!=='[]').filter(item=> JSON.parse(item.employees)[0].Users_ID===this.userId)
          }
          this.allTargets.forEach((record) => {
            record.startDate = this.ToJalaliDate(record.startDate)
            record.endDate = this.ToJalaliDate(record.endDate)
            record.cities = eval(record.cities)
            record.states = eval(record.states)
            record.zones = eval(record.zones)
            record.goodsGroup = eval(record.goodsGroup)
            record.goods = eval(record.goods)
            record.guild = eval(record.guild)
          })
        })
      } else {
        this.getArchiveSaleTaret().then((res) => {
          this.isArchived = true
          this.allTargets = this.lodash.orderBy(res, item=> item.startDate, 'desc')
          this.allTargets.forEach((record) => {
            record.startDate = this.ToJalaliDate(record.startDate)
            record.endDate = this.ToJalaliDate(record.endDate)
            record.cities = eval(record.cities)
            record.states = eval(record.states)
            record.zones = eval(record.zones)
            record.goodsGroup = eval(record.goodsGroup)
            record.goods = eval(record.goods)
            record.guild = eval(record.guild)
          })
        })
      }
    }
  },
  watch: {
    "newTarget.states": function (val) {
      if (!val || val.length === 0) {
        this.cityOptions = []
      } else {
        const selectedStates = val.map(item => item.State_ID)
        this.cityOptions = this.cityList.filter(item => selectedStates.includes(item.State_ID))
      }
    },
    "newTarget.goodsGroup": function (val) {
      if (!val || val.length === 0) {
        this.goodsOptions = []
      } else {
        this.getGoodsList({goodsGroup: val, selectedStore: []}).then((res) => {
          this.goodsList = res;
          this.goodsOptions = this.goodsList;
        })
      }
    },
    "newTarget.goods": function (val) {
      if (val) {
        this.goodsListTarget = Object.assign([], val)
      }
    },
  },
  created() {
    if (this.$q.screen.lt.md) {
      this.targetListPanelVisibility = false
      this.newTargetPanelVisibility = true
    }
    this.loadData()
  }
}
</script>

<style scoped>
.my-class > td:before {
  background: rgba(0, 0, 0, 0) !important;
  border: none;
}
</style>
